import { Tag, TagType } from '@common/atoms/Tag';
import { type ContextData, type ResolvedContextData } from '@common/defaults/ContextData';
import { WidgetType } from '@common/types/Sidebar';
import { getT, Ns } from '@web/i18n';
import { NewsBlockList } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockList';
import { NewsBlockListItem } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockListItem';
import { type NewsBlockListItemProps } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

interface Props {
    contextData: ResolvedContextData;
    dataList?: NewsBlockListItemProps[];
    isTabbedWidget?: boolean;
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'pro.title',
    type: WidgetType.PRO_NEWS,
    icon: (contextData: ContextData) => <Tag type={TagType.PREMIUM} contextData={contextData} />,
};

// FIXME: PB-6012 - Handle (1) Pro uitgelicht widget data-fetching and layout in sidebar
export const Widget = ({ contextData, dataList, isTabbedWidget }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    return (
        <SimpleWidget
            contextData={contextData}
            title={title}
            header={isTabbedWidget ? null : widgetConfig.icon ? widgetConfig.icon(contextData) : null}
            isPremium={isTabbedWidget ? undefined : 'inverted'}
            isTabbedWidget={isTabbedWidget}
        >
            <NewsBlockList>
                {dataList?.map((data, i) => (
                    <NewsBlockListItem key={i} contextData={contextData} {...data} />
                ))}
            </NewsBlockList>
        </SimpleWidget>
    );
};
